// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "../utils/Generic.bs.js";
import * as DeccoAdapter$ApiTypes from "../utils/DeccoAdapter.bs.js";

function customShape_toJson(param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "width",
                Curry._1(Generic$ApiTypes.Encode.$$int, param.width)
              ],
              [
                "height",
                Curry._1(Generic$ApiTypes.Encode.$$int, param.height)
              ]
            ]);
}

var customShape_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "width", Generic$ApiTypes.Decode.$$int), Curry._2(Generic$ApiTypes.Decode.field, "height", Generic$ApiTypes.Decode.$$int), (function (width, height) {
        return {
                width: width,
                height: height
              };
      }));

function shape_toJson(v) {
  if (typeof v !== "number") {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "Custom", customShape_toJson);
  }
  switch (v) {
    case /* Tall */0 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Tall"], Generic$ApiTypes.Encode.string);
    case /* Square */1 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Square"], Generic$ApiTypes.Encode.string);
    case /* Circle */2 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Circle"], Generic$ApiTypes.Encode.string);
    
  }
}

var customDecoder = Generic$ApiTypes.Decode.deccoVariantWithPayload("Custom", customShape_fromJson, (function (param) {
        return /* Custom */{
                _0: {
                  width: param.width,
                  height: param.height
                }
              };
      }));

var shape_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, customDecoder, [Generic$ApiTypes.Decode.simpleVariant([
            [
              "Circle",
              /* Circle */2
            ],
            [
              "Square",
              /* Square */1
            ],
            [
              "Tall",
              /* Tall */0
            ]
          ])]);

function size_toJson(v) {
  switch (v) {
    case /* Small */0 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Small"], Generic$ApiTypes.Encode.string);
    case /* Medium */1 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Medium"], Generic$ApiTypes.Encode.string);
    case /* Large */2 :
        return Curry._2(Generic$ApiTypes.Encode.array, ["Large"], Generic$ApiTypes.Encode.string);
    
  }
}

var size_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "Small",
        /* Small */0
      ],
      [
        "Medium",
        /* Medium */1
      ],
      [
        "Large",
        /* Large */2
      ]
    ]);

function sliderStyles_toJson(param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "shape",
                shape_toJson(param.shape)
              ],
              [
                "size",
                size_toJson(param.size)
              ]
            ]);
}

var sliderStyles_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "shape", shape_fromJson), Curry._2(Generic$ApiTypes.Decode.field, "size", size_fromJson), (function (shape, size) {
        return {
                shape: shape,
                size: size
              };
      }));

function inlineStyles_toJson(param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "span",
                customShape_toJson(param.span)
              ],
              [
                "startRowOffset",
                Curry._1(Generic$ApiTypes.Encode.$$int, param.startRowOffset)
              ]
            ]);
}

var inlineStyles_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "span", customShape_fromJson), Curry._2(Generic$ApiTypes.Decode.field, "startRowOffset", Generic$ApiTypes.Decode.$$int), (function (span, startRowOffset) {
        return {
                span: span,
                startRowOffset: startRowOffset
              };
      }));

function toJson(v) {
  if (v.TAG === /* SliderLayout */0) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "SliderLayout", sliderStyles_toJson);
  } else {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "InlineLayout", inlineStyles_toJson);
  }
}

var fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("SliderLayout", sliderStyles_fromJson, (function (styles) {
            return {
                    TAG: /* SliderLayout */0,
                    _0: styles
                  };
          })), [Generic$ApiTypes.Decode.deccoVariantWithPayload("InlineLayout", inlineStyles_fromJson, (function (styles) {
              return {
                      TAG: /* InlineLayout */1,
                      _0: styles
                    };
            }))]);

var include = DeccoAdapter$ApiTypes.Make({
      toJson: toJson,
      fromJson: fromJson
    });

var RelatedMedia_t_encode = include.t_encode;

var RelatedMedia_t_decode = include.t_decode;

var RelatedMedia_codec = include.codec;

var RelatedMedia = {
  customShape_toJson: customShape_toJson,
  customShape_fromJson: customShape_fromJson,
  shape_toJson: shape_toJson,
  shape_fromJson: shape_fromJson,
  size_toJson: size_toJson,
  size_fromJson: size_fromJson,
  sliderStyles_toJson: sliderStyles_toJson,
  sliderStyles_fromJson: sliderStyles_fromJson,
  inlineStyles_toJson: inlineStyles_toJson,
  inlineStyles_fromJson: inlineStyles_fromJson,
  toJson: toJson,
  fromJson: fromJson,
  t_encode: RelatedMedia_t_encode,
  t_decode: RelatedMedia_t_decode,
  codec: RelatedMedia_codec
};

export {
  RelatedMedia ,
}
/* customShape_fromJson Not a pure module */
